import {Component} from "../Component";
import {element} from "../CustomElement";
import {Page} from "../flipp-page/Page";
import {i18n} from "../../i18n/I18n";
import {AuthenticationService} from "../../services/AuthenticationService";
import {inject} from "../../services/di";
import {ConfigService} from "../../services/ConfigService";
import {LocationService} from "../../services/LocationService";
import {AnalyticsService} from "../../services/AnalyticsService";
import {AccountsService} from "../../services/AccountsService";
import {AuthStatus} from "../../services/definitions/IAuthenticationService";
import {EventService} from "../../services/EventService";
import {LinkService} from "../../services/LinkService";

@element("flipp-data-form")
export class CCPAForm extends Component<{}, void> {
	@inject auth: AuthenticationService;
	@inject config: ConfigService;
	@inject location: LocationService;
	@inject analytics: AnalyticsService;
	@inject fetchUserData: AccountsService;
	@inject eventService: EventService;
	@inject linkService: LinkService;

	refs: {
		formInputNameFirst: HTMLInputElement;
		formInputNameLast: HTMLInputElement;
		formInputEmail: HTMLInputElement;
		radioReceive: HTMLInputElement;
		radioDelete: HTMLInputElement;
		radioNotSell: HTMLInputElement;
		residenceCheckBox: HTMLInputElement;
		errorMsg0: HTMLElement;
		errorMsg1: HTMLElement;
		errorMsg2: HTMLElement;
		submitForm: HTMLFormElement;
		submitBtn: HTMLInputElement;
		modalWrapper: HTMLDivElement;
		modalDelete: HTMLDivElement;
		closeModalBtn: HTMLButtonElement;
		acceptDeleteBtn: HTMLButtonElement;
		modalError: HTMLDivElement;
		errorTextField: HTMLElement;
		infoBtn: HTMLElement;
		tooltipText: HTMLDivElement,
		dataFormWrapper: HTMLDivElement,
		spinner: HTMLElement
	};

	state = {
		dataAction: "receive",
		firstName: "",
		lastName: "",
		email: "",
		residenceCalifornia: false,
		access_token: "",
		user_id: "",
		sid: "",
		fsa: "",
		application_version: "",
		locale : "",
		country_code: ""
	};

	onAttach() {
		const form = this.refs.submitForm;
		const inputsNoSubmitBtn = 7;
		for (let i = 0; i < inputsNoSubmitBtn; i++) {
			form[i].addEventListener("change", this.handleChange);
		}
		this.refs.closeModalBtn.addEventListener("click", this.handleCloseModal);
		this.refs.acceptDeleteBtn.addEventListener("click", this.acceptDeleteData);
		window.addEventListener("redirect-from-form", this.changeUserLocation);
		window.addEventListener("flipp-auth", this.checkEmail);
		window.addEventListener("redirect-logout-form", this.changeUserLocation);
		this.refs.infoBtn.addEventListener("mouseenter", this.showPopUp);
		this.refs.infoBtn.addEventListener("mouseleave", this.hidePopUp);
		this.state.dataAction = "receive";
		this.state.firstName = "";
		this.state.lastName = "";
		this.state.email = "";
		this.state.residenceCalifornia = false;
		this.checkSignIn();
		this.checkEmail();
	}

	onDetach() {
		const form = this.refs.submitForm;
		const inputsNoSubmitBtn = 7;
		for (let i = 0; i < inputsNoSubmitBtn; i++) {
			form[i].removeEventListener("change", this.handleChange);
		}
		this.refs.closeModalBtn.removeEventListener("click", this.handleCloseModal);
		this.refs.acceptDeleteBtn.removeEventListener("click", this.acceptDeleteData);
		window.removeEventListener("redirect-from-form", this.changeUserLocation);
		window.removeEventListener("flipp-auth", this.checkEmail);
		window.removeEventListener("redirect-logout-form", this.changeUserLocation);
		this.refs.infoBtn.removeEventListener("mouseenter", this.showPopUp);
		this.refs.infoBtn.removeEventListener("mouseleave", this.hidePopUp);
	}

	render() {
		return <Page show="flyers">
			<section ref="spinner" class="main">
				<div class="loading">
					<div class="spinner"></div>
				</div>
			</section>
			<div ref="dataFormWrapper" class="data-form-wrapper">
				<h3>Your Data Choices</h3>
				<div class="form-text">{i18n("my_data_text")}<span ref="infoBtn" class="info-button">i</span>
					<span ref="tooltipText" class="tooltip-text">{i18n("my_tooltip_text")}</span>
				</div>
				<form
					name="dataForm"
					onSubmit={this.handleSubmit}
					class="form-inputs"
					ref="submitForm"
				>
					<input
						type="text"
						name="firstName"
						placeholder="First Name"
						ref="formInputNameFirst"
						maxLength= {100}
					/>
					<p ref="errorMsg0" class="error-msg"></p>
					<input
						type="text"
						name="lastName"
						placeholder="Last Name"
						ref="formInputNameLast"
						maxLength= {100}
					/>
					<p ref="errorMsg1" class="error-msg"></p>
					<input
						type="email"
						name="email"
						placeholder="Email"
						ref="formInputEmail"
						maxLength= {100}
						pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
					/>
					<p ref="errorMsg2" class="error-msg"></p>
					<label>Select your data request below</label>
					<div class="radio-group">
						<div class="radio-option">
							<input
								type="radio"
								id="receive"
								name="dataAction"
								value="receive"
								ref="radioReceive"
								checked
							/>
							<label for="receive">Receive a copy of my data
								<div class="radio-text">We will send you a copy of the personal information that you
									have provided us with, or that we have collected about you, based on the identifiers
									you have given us.</div>
							</label>
						</div>
						<div class="radio-option">
							<input
								type="radio"
								id="delete"
								name="dataAction"
								value="delete"
								ref="radioDelete"
							/>
							<label for="delete">Delete my data
								<div class="radio-text">We will delete, aggregate, or de-identify the personal
									information that you have provided us with, or that we have collected about you,
									based on the identifiers you have given us.</div>
							</label>
						</div>
						<div class="radio-option">
							<input
								type="radio"
								id="notSell"
								name="dataAction"
								value="notSell"
								ref="radioNotSell"
							/>
							<label for="notSell">Do not sell my data
								<div class="radio-text">We will not sell the personal information that you have provided
									us with, or that we have collected about you, to third parties</div>
							</label>
						</div>
					</div>
					<div class="residence-wrapper">
						<input
							id="residenceCalifornia"
							name="residenceCalifornia"
							ref="residenceCheckBox"
							type="checkbox"
						/>
						<label for="residenceCalifornia" class="residence">I am a resident of California, USA
							<div class="radio-text">I hereby declare under penalty of perjury that I am the
								consumer whose personal information is the subject of the request made in this form.</div>
						</label>
					</div>
					<div class="disclaimer-text">If you have any questions or concerns with respect to this form or your rights pursuant to the
						CCPA, please review our privacy policy available at https://corp.flipp.com/privacy. We are
						required to verify your identity before responding to any request for information or request to
						delete, and will do so by matching the personal information you provide in this form with the
						information contained in our systems. If you would like to know the categories of information
						Flipp collects with respect to all users, please refer to the privacy policy.</div>
					<input
						class="submit"
						type="submit"
						value="Submit"
						ref="submitBtn"
						disabled
					/>
				</form>
			</div>
			<div ref="modalWrapper" class="modal-wrapper">
			</div>
			<div ref="modalDelete" class="modal-delete">
				<h1>Permanently delete your Flipp data?</h1>
				<p>Note that this process is not reversible and you will permanently lose any personalization or
					customization of your experience.</p>
				<div class="modalBtnWrapper">
					<button class="closeModalBtn" ref="closeModalBtn">Cancel</button>
					<button class="acceptModalBtn" ref="acceptDeleteBtn">Request Deletion</button>
				</div>
			</div>
			<div ref="modalError" class="modal-delete">
				<h1><span>Error</span></h1>
				<p ref="errorTextField"></p>
				<div class="modalBtnWrapper">
					<button onClick={this.handleCloseModal} class="closeModalBtn">Ok</button>
				</div>
			</div>
		</Page>;
	}

	private handleSubmit = (e: any) => {
		e.preventDefault();
		const form = this.refs.submitForm;
		const textInputs = 3;
		let inputsFilled = [];
		for (let i = 0; i < textInputs; i++) {
			if (form[i].value.length === 0) {
				form[i].style.borderColor = "red";
				if (form[0].value.length === 0 && form[1].value.length === 0 && form[2].value.length === 0) {
					this.refs.errorMsg0.textContent = "Please enter your first name";
					this.refs.errorMsg1.textContent = "Please enter your last name";
					this.refs.errorMsg2.textContent = "Please enter a valid email address";
				} else if (form[0].value.length === 0 && form[1].value.length === 0) {
					this.refs.errorMsg0.textContent = "Please enter your first name";
					this.refs.errorMsg1.textContent = "Please enter your last name";
				} else if (form[1].value.length === 0 && form[2].value.length === 0) {
					this.refs.errorMsg1.textContent = "Please enter your last name";
					this.refs.errorMsg2.textContent = "Please enter a valid email address";
				} else if (form[0].value.length === 0) {
					this.refs.errorMsg0.textContent = "Please enter your first name";
				} else if (form[1].value.length === 0) {
					this.refs.errorMsg1.textContent = "Please enter your last name";
				} else if (form[2].value.length === 0) {
					this.refs.errorMsg2.textContent = "Please enter a valid email address";
				}
			} else {
				inputsFilled.push("check");
				form[i].style.borderColor = "grey";
			}
		}
		if (inputsFilled.length === textInputs && this.state.dataAction === "receive") {
			this.receiveCopyData();
		} else if (inputsFilled.length === textInputs && this.state.dataAction === "delete") {
			this.refs.modalWrapper.classList.add("showed");
			this.refs.modalDelete.classList.add("showed");
		} else if (inputsFilled.length === textInputs && this.state.dataAction === "notSell") {
			this.notSellData();
		}
	}

	private handleChange = (e: any) => {
		Object.assign(this.state, {[e.target.name]: e.target.value});
		if (e.target.name === "residenceCalifornia") {
			if (e.target.checked === true) {
				this.refs.submitBtn.classList.add("active");
				this.refs.submitBtn.removeAttribute("disabled");
			} else {
				this.refs.submitBtn.classList.remove("active");
				this.refs.submitBtn.setAttribute("disabled", "disabled");
			}
			Object.assign(this.state, {[e.target.name]: e.target.checked});
		} else if (e.target.name !== "dataAction") {
			e.target.style.borderColor = "grey";
			this.refs.errorMsg0.textContent = "";
			this.refs.errorMsg1.textContent = "";
			this.refs.errorMsg2.textContent = "";
		}
	}

	private handleCloseModal = (e: any) => {
		e.preventDefault();
		this.refs.modalWrapper.classList.remove("showed");
		this.refs.modalDelete.classList.remove("showed");
		this.refs.modalError.classList.remove("showed");
	}

	private acceptDeleteData = async (e: any) => {
		e.preventDefault();
		this.refs.modalWrapper.classList.remove("showed");
		this.refs.modalDelete.classList.remove("showed");
		this.refs.radioDelete.checked = true;
		this.state.dataAction = "delete";
		this.refs.spinner.classList.add("not-hide");
		this.refs.dataFormWrapper.classList.add("transparent");
		try {
			await this.fetchUserData.deleteUserData(this.state);
			this.refs.spinner.classList.remove("not-hide");
			this.refs.dataFormWrapper.classList.remove("transparent");
			this.linkService.execute("/data/success", this);
		}	catch (e) {
			this.handleSubmitError(e);
			}
	}

	private receiveCopyData = async () => {
		this.refs.spinner.classList.add("not-hide");
		this.refs.dataFormWrapper.classList.add("transparent");
		try {
			await this.fetchUserData.receiveCopyData(this.state);
			this.refs.spinner.classList.remove("not-hide");
			this.refs.dataFormWrapper.classList.remove("transparent");
			this.linkService.execute("/data/success", this);
		} catch (e) {
			this.handleSubmitError(e);
			}
	}

	private notSellData = async () => {
		this.refs.spinner.classList.add("not-hide");
		this.refs.dataFormWrapper.classList.add("transparent");
		try {
			await this.fetchUserData.notSellData(this.state);
			this.refs.spinner.classList.remove("not-hide");
			this.refs.dataFormWrapper.classList.remove("transparent");
			this.linkService.execute("/data/success", this);
		} catch (e) {
			this.handleSubmitError(e);
			}
	}

	private handleSubmitError = (error: any) => {
		this.refs.errorTextField.textContent = error.message;
		this.refs.modalWrapper.classList.add("showed");
		this.refs.modalError.classList.add("showed");
		this.refs.spinner.classList.remove("not-hide");
		this.refs.dataFormWrapper.classList.remove("transparent");
	}

	private checkEmail = () => {
		if (this.auth.status === AuthStatus.LOGGED_IN && this.auth.user.info.email) {
			const loginUserEmail = `${this.auth.user.info.email}`;
			this.refs.formInputEmail.value = loginUserEmail;
			this.state.email = loginUserEmail;
			this.refs.formInputEmail.setAttribute("disabled", "disabled");
		}
		this.getToken();
	}

	private getToken = () => {
		if (this.auth.status === AuthStatus.LOGGED_IN) {
			window.removeEventListener("redirect-from-form", this.changeUserLocation);
			const appVersionArray = this.config.BUILD.split("/");
			const countryCodeArray = this.location.locale.split("-");
			this.state.application_version = appVersionArray[appVersionArray.length - 1];
			this.state.sid = this.analytics.sessionId;
			this.state.fsa = this.location.postalCode;
			this.state.locale = this.location.locale;
			this.state.country_code = countryCodeArray[countryCodeArray.length - 1].toUpperCase();
			this.state.user_id = this.auth.user.token["user_id"];
			this.state.access_token = this.auth.user.token["access_token"];
		}
	}

	private changeUserLocation = () => {
		this.linkService.execute("/flyers", this);
	}

	private checkSignIn = () => {
		if (this.auth.status !== AuthStatus.LOGGED_IN) {
			this.eventService.showModalInForm();
		}
	}

	private showPopUp = () => {
		this.refs.infoBtn.classList.add("pseudo");
		this.refs.tooltipText.classList.add("not-hide");
}

	private hidePopUp = () => {
		this.refs.infoBtn.classList.remove("pseudo");
		this.refs.tooltipText.classList.remove("not-hide");
	}
}
